import { getInstance } from './auth0Plugin'
import { Tenant } from '../api'
import { storeUserInLocalStorage } from '../helpers'
import {
  CGroup,
  CGroupEnd,
  CIGroup,
  CLog,
} from '../consoleMixin'
import FactoringAPI from '../FactoringAPI'

const isMobileCheck = (to) => {
  CGroup('%cisMobileCheck: Is route mobile friendly?', 'color: orange')

  let yes = true
  if (to.matched.some((record) => {
    return record.meta.mobileFriendly
  })) {
    CLog('%cYes', 'color: orange')
  }
  else {
    CLog('%cNo', 'color: orange')
    yes = false
  }

  CGroupEnd()
  return yes
}
const maintenanceModeCheck = async () => {
  CGroup('%cmaintenanceModeCheck: Is maintenance active?', 'color: orange')

  const isMaintenanceMode = (await new FactoringAPI().getMaintenanceMode()).isEnabled
  let yes = true
  if (isMaintenanceMode) {
    CLog('%cYes', 'color: orange')
  }
  else {
    CLog('%cNo', 'color: orange')
    yes = false
  }

  CGroupEnd()
  return yes
}
const mobileCriteria = window.matchMedia('(max-width: 1024px)').matches
const routeAuthenticationRequired = (to) => {
  CGroup('%crouteAuthenticationRequired: Does route require authentication?', 'color: orange')

  let yes = true
  if (to.matched.some((record) => {
    return record.meta.requiresAuth
  })) {
    CLog('%cYes', 'color: orange')
  }

  if (to.matched.some((record) => {
    return record.meta.guest
  })) {
    CLog('%cNo', 'color: orange')
    yes = false
  }

  CGroupEnd()
  return yes
}
const userAuthenticationCheck = (authService) => {
  CGroup('%cuserAuthenticationCheck: Is the user authenticated?', 'color: orange')

  let yes = true
  if (authService.isAuthenticated()) {
    CLog('%cYes', 'color: orange')
  }
  else {
    CLog('%cNo', 'color: orange')
    yes = false
  }

  CGroupEnd()
  return yes
}
const userAuthorizationCheck = (to) => {
  CGroup('%cuserAuthorizationCheck: Does the user have authorization?', 'color: orange')

  const user = JSON.parse(localStorage.getItem('user'))
  let yes = true
  // Requires Client+
  if (to.matched.some((record) => {
    return record.meta.requiresClient
  })) {
    CLog('%cRoute requires client+', 'color: orange')
    if (userType.isClient(user) || userType.isEmployee(user)) {
      CLog('%cYes', 'color: orange')
    }
    else {
      CLog('%cNo', 'color: orange')
      yes = false
    }
  }

  // Requires Employee+
  if (to.matched.some((record) => {
    return record.meta.requiresEmployee
  })) {
    CLog('%cRoute requires employee+', 'color: orange')
    if (userType.isEmployee(user)) {
      CLog('%cYes', 'color: orange')
    }
    else {
      CLog('%cNo', 'color: orange')
      yes = false
    }
  }

  // Requires Master
  if (to.matched.some((record) => {
    return record.meta.requiresMaster
  })) {
    CLog('%cRoute requires master', 'color: orange')
    if (userType.isEmployee(user) && userType.isMaster(user)) {
      CLog('%cYes', 'color: orange')
    }
    else {
      CLog('%cNo', 'color: orange')
      yes = false
    }
  }

  CGroupEnd()
  return yes
}
const userInfoInLSCheck = () => {
  CGroup('%cUserInfoInLSCheck: Is user stored in LS', 'color: orange')

  const user = JSON.parse(localStorage.getItem('user'))
  let yes = true
  if (user) {
    CLog('%cYes', 'color: orange')
  }
  else {
    CLog('%cNo', 'color: orange')
    yes = false
  }

  CGroupEnd()
  return yes
}
const userType = {
  isClient: (user) => {
    if (user && user.client) {
      return true
    }
    return false
  },
  isEmployee: (user) => {
    if (user && user.employee) {
      return true
    }
    return false
  },
  isMaster: (user) => {
    if (user && user.employee && user.employee.is_master) {
      return true
    }
    return false
  },
}

export const authGuard = async (to, from, next) => {
  const authService = getInstance()
  const user = JSON.parse(localStorage.getItem('user'))

  const nextFn = async () => {
    CIGroup(`%cAuthGuard (to: ${to.name}, from: ${from.name})`, 'color: orange')

    // if returnNext is true, then we perform the last step - checking if the user has authorization
    let returnNext = false

    // Does the route require authentication?
    if (routeAuthenticationRequired(to)) {
      // Yes, is the user authenticated?
      if (userAuthenticationCheck(authService)) {
        // Yes, is the user's DB info in local storage?
        if (userInfoInLSCheck()) {
          // Yes, is the application currently in maintenance mode?
          if (await maintenanceModeCheck()) {
            // Yes, is the route maintenance mode friendly?
            if (to.matched.some((record) => {
              return record.meta.maintenanceFriendly
            })) {
              // Yes, is the user a master employee?
              if (userType.isEmployee(user) && userType.isMaster(user)) {
                // Send them on their way!
                returnNext = true
              }
              // No, they're not :(
              else {
                CGroupEnd()
                return next({ name: 'maintenance' })
              }
            }
            // No, it is not a maintenance mode friendly route
            else {
              CGroupEnd()
              return next({ name: 'maintenance' })
            }
          }
          // No, the application is not currently in maintenance mode
          else {
            // Are we viewing on mobile?
            if (mobileCriteria) {
              // Yes, is the route mobile friendly?
              if (isMobileCheck(to)) {
                returnNext = true
              }
              // No, it is not mobile friendly :|
              else {
                CGroupEnd()
                return next({
                  name: 'permission-denied',
                  params: {
                    reason: 'This page is not yet converted for mobile viewing. We apologize for the inconvenience. If you would like to be able to access this page on mobile please reach out to Bobtail!',
                    title: 'Inaccessible on mobile',
                  },
                })
              }
            }
            // No, we are not, send them on their way! :)
            else {
              returnNext = true
            }
          }
        }
        // No, try fetching it again
        else {
          await storeUserInLocalStorage()
          // Recursively call nextFn to restart the checks
          await nextFn()
        }
      }
      // No, authenticate them!
      else {
        CLog('%cNot authenticated; triggering login via redirect', 'color: orange')
        CGroupEnd()
        return await authService.loginWithRedirect({
          appState: {
            targetUrl: to.fullPath,
          },
        })
      }
    }
    // No, it is a guest route
    else {
      CGroupEnd()
      return next()
    }

    // Final check - is the user authorized to access this route
    if (returnNext) {
      CLog('%cPerforming authorization check', 'color: orange')
      if (userAuthorizationCheck(to)) {
        CLog('%cAuthorized', 'color: orange')
        CGroupEnd()
        return next()
      }
      else {
        CLog('%cUnauthorized', 'color: orange')
        CGroupEnd()
        return next({ name: 'permission-denied', params: { reason: 'You do not have permission to view this page' } })
      }
    }
  }

  // Watch for the auth0 loading property to change before we check isAuthenticated
  if (authService.loading) {
    CLog('%cAuthGuard: authService is still loading', 'color: orange')
    authService.$watch('loading', async (loading) => {
      CLog('%cAuthGuard: setting up watcher', 'color: orange')
      if (loading === false) {
        CLog('%cAuthService: loaded', 'color: orange')
        await nextFn()
      }
    })
  }
  else {
    CLog('%cAuthGuard: already loaded', 'color: orange')
    await nextFn()
  }
}
